import { v4 as uuidv4 } from 'uuid'

export function generateTokenDeviceId() {
  const id = uuidv4()

  return id
}

export const getDeviceDescription = () => {
  let platform

  const userAgent = navigator.userAgent

  if (userAgent.match(/chrome|chromium|crios/i)) {
    platform = 'Chrome'
  } else if (userAgent.match(/firefox|fxios/i)) {
    platform = 'Firefox'
  } else if (userAgent.match(/safari/i)) {
    platform = 'Safari'
  } else if (userAgent.match(/opr\//i)) {
    platform = 'Opera'
  } else if (userAgent.match(/edg/i)) {
    platform = 'Edge'
  } else {
    platform = 'Navegador Desconhecido'
  }

  return `Platform: ${platform}`
}

export const isMobile = () => {
  const userAgent = navigator.userAgent

  return /android|iphone|ipod/i.test(userAgent)
}
